var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"v5-tab-item",class:{'v5-tab-item-selected':_vm.isSelected},attrs:{"href":"javascript:;"},on:{"click":_vm.updateActiveId}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }